module.exports = __webpack_public_path__ + "img/appcard.da2e45d6.png";